import { createSlice } from "@reduxjs/toolkit";

const selectedCustomerBuildingSlice = createSlice({
  name: "selectedCustomerBuilding",
  initialState: null,
  reducers: {
    setSelectedCustomerBuilding: (state, action) => {
      return action.payload;
    },
    clearSelectedCustomerBuilding: () => {
      return null;
    },
  },
});

export const { setSelectedCustomerBuilding, clearSelectedCustomerBuilding } =
  selectedCustomerBuildingSlice.actions;
export const selectSelectedCustomerBuilding = (state) =>
  state.selectedCustomerBuilding;

export default selectedCustomerBuildingSlice.reducer;
